<template>
  <div class="settings-wrapper">
    <div class="route-name">{{ $t(`message.sideMenu.${this.$route.name}`) }}</div>
    <div class="settings-container">
      <div class="button-block">
        <base-button
          :text="$t('message.settingsPage.btn')"
          @click="$router.push({name: 'change-password'})"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BaseButton from '../../components/base/BaseButton.vue';

export default {
  name: 'Settings',
  components: {
    BaseButton
  }
}
</script>

<style lang="scss" scoped>
  .settings-wrapper {
    @include page-wrapper-with-header-and-footer;

    padding-top: 40px;
    box-sizing: border-box;
  }

  .settings-container {
    @include base-page-container;

    padding-top: 50px;
  }

  .button-block {
    width: 265px;
    height: 65px;
  }

  .route-name {
    @include route-name;
    width: 95%;
    text-align: start;
    margin-bottom: 0;
    margin-top: -20px;
  }
</style>